import type { KgInsightSubscriptionCategory } from '@api/api/event-alerts';

export interface AlertTrackingProperties {
  id?: string;
  source_id: string;
  source_type: string;
  category?: KgInsightSubscriptionCategory;
  created_at?: string;
}

export const getAlertProperties = (alertData: AlertTrackingProperties) => ({
  ...(alertData.id ? { alert_id: alertData.id } : {}),
  source_id: alertData.source_id,
  alert_type: alertData.source_type,
  ...(alertData.category ? { category: alertData.category } : {}),
  ...(alertData.created_at
    ? {
        alert_age_seconds: Math.floor(
          (Date.now() - new Date(alertData.created_at).getTime()) / 1000
        ),
      }
    : {}),
});
